module.exports = __webpack_public_path__ + "img/record-logo.b390d896.png";